import {
  Modal,
  Form,
  Input,
  Button,
  Radio,
  Select,
  Tabs,
  Row,
  Col,
  message,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import IntlMessage from "../../../components/IntlMessage";
import { field_payment_method } from "../../../utils/constant";
import paymentMethodApi from "../../../api/paymentMethod";
import { useSelector } from "react-redux";
import opPaymentMethodsApi from "../../../api/op-payment-method";

const PaymentSettingForm = (props) => {
  const {
    isModalOpen,
    setOpenModal,
    currentData,
    onModalClose,
    onRefresh,
  } = props;
  const [paymentOption, setPaymentOption] = useState([]);
  const [operatorSelected, setOperatorSelected] = useState();
  const [paymentSelected, setPaymentSelected] = useState();
  const isMounted = useRef(null);
  const operator = useSelector((state) => state.auth.operator);

  const isMobile = window.innerWidth < 576;
  const fetch = useCallback(async () => {
    try {
      if (isMounted) {
        const filter = {
          page: 1,
          limit: 9999,
          order_by: "id",
          order_dir: "DESC",
          keyword: "",
        };
        const payment = await paymentMethodApi.getAll(filter);

        const list_payment = payment.data.map((item) => {
          return {
            label: item.display || item.id,
            value: item.id,
          };
        });
        setPaymentOption(list_payment);
      }
    } catch (err) {
      console.log(err);
    }
  }, [isMounted]);

  useEffect(() => {
    isMounted.current = true;
    fetch();
  }, [fetch]);

  const initialValues = {
    ...currentData,
    status: currentData && currentData.status ? 1 : 0,
    is_on_userapp: currentData && currentData.is_on_userapp ? 1 : 0,
    is_on_operatorapp: currentData && currentData.is_on_operatorapp ? 1 : 0,
    fee: currentData && currentData.fee ? currentData.fee : "",
    is_fee_default:
      currentData && currentData.is_fee_default
        ? currentData.is_fee_default
        : "",
    payment_method:
      currentData && currentData.payment_method
        ? currentData.payment_method
        : "",
    wave_template_sms:
      currentData && currentData.wave_template_sms
        ? currentData.wave_template_sms
        : "",
    suffix_userapp:
      currentData && currentData.suffix_userapp
        ? currentData.suffix_userapp
        : "",
    suffix_operatorapp:
      currentData && currentData.suffix_operatorapp
        ? currentData.suffix_operatorapp
        : "",
    meta_data:
      currentData && _.isArray(JSON.parse(currentData.field)) === true
        ? field_payment_method.map((key) =>
            _.chain(JSON.parse(currentData.field))
              .keyBy("code")
              .mapValues("value")
              .value()
          )
        : field_payment_method.map((key) => ({
            [key]:
              currentData && currentData.field
                ? JSON.parse(currentData.field)[key] || ""
                : "",
          })),
  };

  const onChangePayment = (value) => {
    setPaymentSelected(value);
    // const list_payment = paymentOption.filter((item) => {
    //   console.log("check item: ", item);
    //   // return item.payment.id !== paymentSelected;
    //   return item.value !== paymentSelected;
    // });

    // setPaymentOption(list_payment);
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };

  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        let data = {
          ...values,
          operator: operatorSelected,
          payment_method: paymentSelected,
        };
        const field = [];
        let combinedObject = {};
        currentData &&
          data.meta_data.forEach((item) => {
            if (_.isArray(JSON.stringify(currentData.field))) {
              const key = Object.keys(item);
              const value = item[key];
              combinedObject[key] = value;
            } else {
              Object.keys(item).forEach((key) => {
                combinedObject[key] = item[key];
              });
            }
          });
        if (combinedObject) {
          field.push(combinedObject);
          data = {
            ...data,
            field: JSON.stringify(combinedObject),
          };
        }
        if (currentData) {
          delete values.operator_id;
          delete values.payment_method_id;

          const update = await opPaymentMethodsApi.update(currentData.id, data);
          if (update) {
            message.success("Updated successfully");
            setOpenModal(false);
            onRefresh();
          }
        } else {
          values.operator_id = operator?.id;
          let addData = {
            ...values,
          };
          console.log(values);
          if (values.meta_data) {
            const arrToObj = Object.assign({}, ...values.meta_data);
            addData = {
              ...addData,
              field: JSON.stringify(arrToObj),
            };
          }

          await opPaymentMethodsApi.create(addData);
          setOpenModal(false);
          onRefresh();
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const tabItems = [
    {
      label: <IntlMessage id="global.payment" />,
      key: "1",
      children: (
        <>
          <Form.Item
            label="Payment Method"
            name="payment_method_id"
            rules={[
              {
                required:
                  currentData && currentData.payment_method ? false : true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Select
              defaultValue={
                currentData && currentData.payment_method
                  ? currentData.payment_method.display
                  : ""
              }
              style={{
                width: 240,
              }}
              onChange={onChangePayment}
              options={paymentOption}
            />
          </Form.Item>

          <Form.Item label="Wave template sms" name="wave_template_sms">
            <Input placeholder="Input Title" />
          </Form.Item>

          <Form.Item
            label="Fee"
            name="fee"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Suffix Operator App" name="suffix_operatorapp">
            <Input />
          </Form.Item>

          <Form.Item label="Suffix User App" name="suffix_userapp">
            <Input />
          </Form.Item>

          {currentData ? (
            <Form.Item
              label="Status"
              name="status"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}
            >
              <Radio.Group name="radiogroup">
                <Radio value={1}>
                  <IntlMessage id="global.active" />
                </Radio>
                <Radio value={0}>
                  <IntlMessage id="global.inactive" />
                </Radio>
              </Radio.Group>
            </Form.Item>
          ) : null}

          <Form.Item
            label="On User App"
            name="is_on_userapp"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Radio.Group name="radiogroup">
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="On Operator App"
            name="is_on_operatorapp"
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}
          >
            <Radio.Group name="radiogroup">
              <Radio value={1}>
                <IntlMessage id="global.active" />
              </Radio>
              <Radio value={0}>
                <IntlMessage id="global.inactive" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </>
      ),
    },
    {
      label: <IntlMessage id="global.setting" />,
      key: "2",
      forceRender: true,
      children: (
        <>
          <Form.List name="meta_data">
            {(fields, { add }) => {
              const filterFields = fields
                .map((item, index) => {
                  return {
                    ...item,
                    fieldName:
                      field_payment_method[index] === "identifiant"
                        ? "merchant_account"
                        : field_payment_method[index],
                  };
                })
                .filter((field) => field.fieldName !== "merchant_account");
              return (
                <>
                  {filterFields.map((field, index) => {
                    const fieldName = field_payment_method[index];
                    const replaceFieldName =
                      fieldName === "identifiant"
                        ? "merchant_account"
                        : fieldName;

                    if (fieldName === "notify_url") {
                      return (
                        <Form.Item
                          key={field.key}
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          name={[index, fieldName]}
                        >
                          <Input />
                        </Form.Item>
                      );
                    } else if (fieldName === "identifiant") {
                      return (
                        <>
                          <Row gutter={[16, 16]}>
                            <Col key={index} span={6}></Col>
                          </Row>
                          <Form.Item
                            key={field.key}
                            label={
                              <IntlMessage id={`global.${replaceFieldName}`} />
                            }
                            // help={errorMeta}
                            name={[index, fieldName]}
                          >
                            <Input />
                          </Form.Item>
                        </>
                      );
                    } else if (fieldName === "site") {
                      return (
                        <Form.Item
                          key={field.key}
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          name={[index, fieldName]}
                        >
                          <Input />
                        </Form.Item>
                      );
                    } else {
                      return (
                        <Form.Item
                          key={field.key}
                          label={<IntlMessage id={`global.${fieldName}`} />}
                          name={[index, fieldName]}
                        >
                          <Input />
                        </Form.Item>
                      );
                    }
                  })}
                </>
              );
            }}
          </Form.List>
        </>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Modal
        title={
          currentData ? (
            <IntlMessage id="global.edit" />
          ) : (
            <IntlMessage id="global.add" />
          )
        }
        open={isModalOpen}
        onCancel={onModalClose}
        width={isMobile ? "90%" : "50%"}
        footer={[
          <>
            <Button key="back" type="default" onClick={onModalClose}>
              {<IntlMessage id="global.cancel" />}
            </Button>
            <Button key="back" type="primary" onClick={handleOk}>
              {<IntlMessage id="global.save" />}
            </Button>
          </>,
        ]}
      >
        <Form
          name="basic"
          labelAlign="left"
          {...layout}
          className="ml-20"
          initialValues={initialValues}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Tabs defaultActiveKey="1" items={tabItems} />
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default PaymentSettingForm;
